import { useEffect, useState, useMemo } from "react";
import { t } from "i18next";
import { useHistory } from "react-router-dom";
import DataGrid from "../../../core/components/data-grid/DataGrid";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import Helper from "../../../core/Helper";
import ApiService from "../../../core/service/ApiService";
import { Button } from "antd";
import { useModal } from "../../../core/context/ModalContext";

export default function AppLogDataGrid() {

    const history = useHistory();
    const { queryModel, setDataGridProps, setData, setPaginationResult, refreshDataGrid } = useDataGrid();
    const { openModal } = useModal();
    const [appLogTypes, setAppLogTypes] = useState([]);

    // Fetch AppLog types on mount
    useEffect(() => {
        const fetchTypes = async () => {
            const res = await ApiService.AppLog.GetAppLogTypes();
            if (res.success) {
                setAppLogTypes(res.data);
            }
        };
        fetchTypes();
    }, []);

    // Create type lookup map
    const typeMap = useMemo(() => {
        const map = {};
        appLogTypes.forEach(item => {
            map[item.id] = item.name;
        });
        return map;
    }, [appLogTypes]);

    const showJsonModal = (record) => {
        let jsonContent = record.data;
        try {
            // Try to parse and pretty-print JSON
            const parsed = JSON.parse(record.data);
            jsonContent = JSON.stringify(parsed, null, 2);
        } catch (e) {
            // If not valid JSON, show as-is
            jsonContent = record.data;
        }

        openModal(
            `${t('Log Details')} - ${typeMap[record.type] || record.type}`,
            <div style={{ maxHeight: '70vh', overflow: 'auto' }}>
                <pre style={{
                    backgroundColor: '#f5f5f5',
                    padding: '16px',
                    borderRadius: '8px',
                    fontSize: '12px',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word'
                }}>
                    {jsonContent}
                </pre>
            </div>
        );
    };

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: [
                { dataIndex: 'refTable', key: 'refTable', title: t('RefTable') },
                {
                    dataIndex: 'type',
                    key: 'type',
                    title: t('Type'),
                    render: (val, row) => (
                        <Button
                            type="link"
                            size="small"
                            onClick={() => showJsonModal(row)}
                            style={{ padding: 0 }}
                        >
                            {typeMap[val] || val}
                        </Button>
                    )
                },
                { dataIndex: 'description', key: 'description', title: t('Description'), sorter: true },
                {
                    dataIndex: 'user',
                    key: 'user',
                    title: t('User'),
                    render: (val) => val?.name || '-'
                },
                { dataIndex: 'createdDate', key: 'createdDate', title: t('Date'), render: (val, row) => Helper.Date.dateFormat(val) }
            ]
        })
    }, [typeMap])

    const load = async () => {
        const res = await ApiService.AppLog.GetAppLogDataGrid(queryModel);
        if (res.success) {
            setData(res.data)
            setPaginationResult(res.pagination);
        }
    }

    useEffect(() => {
        load()
    }, [queryModel.updateKey])

    return (
        <DataGrid />
    )
}
